var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{ref:"elem",staticClass:"inline-editor",class:{'inline-editor--empty': _vm.val.length === 0},attrs:{"contenteditable":"true"},on:{"input":_vm.handleChange,"paste":_vm.handlePaste}})}
var staticRenderFns = []

export { render, staticRenderFns }